module.exports = __webpack_public_path__ + "system/img/bg.5e62d820.png";